import { Col, Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Buttons, FlatButton } from "../../../Constant";
import FlatDefaultButtons from "./DefaultButtons";
import FlatLargeButtons from "./LargeButtons";
import FlatSmallButtons from "./SmallButtons";
import FlatExtraSmallButtons from "./ExtraSmallButtons";
import FlatActiveButtons from "./ActiveButtons";
import FlatDisabledButtons from "./DisabledButtons";
import FlateCustomStateButtons from "./CustomStateButtons";
import FlatOutlineButtons from "./OutlineButtons";
import FlatBoldBorderOutlineButtons from "./BoldBorderOutlineButtons";
import FlatOutlineLargeButtons from "./OutlineLargeButtons";
import FlatOutlineSmallButtons from "./OutlineSmallButtons";
import FlatOutlineExtraSmallButtons from "./OutlineExtraSmallButtons";
import FlatDisabledOutlineButtons from "./DisabledOutlineButtons";
import FlatGradienButtons from "./GradienButtons";

const FlatStyleContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={FlatButton} parent={Buttons} title={FlatButton} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <FlatDefaultButtons />
            <FlatLargeButtons />
            <FlatSmallButtons />
            <FlatExtraSmallButtons />
            <FlatActiveButtons />
            <FlatDisabledButtons />
            <FlateCustomStateButtons />
            <FlatOutlineButtons />
            <FlatBoldBorderOutlineButtons />
            <FlatOutlineLargeButtons />
            <FlatOutlineSmallButtons />
            <FlatOutlineExtraSmallButtons />
            <FlatDisabledOutlineButtons />
            <FlatGradienButtons />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FlatStyleContainer;
